import actionCreator from 'utils/actionCreator';

export const actions = actionCreator('illustration', [
  'RESET',
  'SLIDES_REQUEST',
  'SLIDES_SUCCESS',
  'ADD_SLIDE',
  'DELETE_SLIDE',
  'SLIDE_REQUEST',
  'SLIDE_SUCCESS',
  'ADD_IMAGE',
  'DELETE_IMAGE',
  'UPLOADING',
  'UPDATE_IMAGE_STYLES',
  'ADD_SLIDE_NOTES',
  'TOGGLE_LOADING',
  'SET_SLIDE_THUMBNAIL',
  'ADD_COMMENT',
  'RESOLVE_COMMENT',
  'EDIT_COMMENT',
  'DELETE_COMMENT',
  'UPDATE_COMMENT_DOT_POSITION',
  'LISTEN_COMMENTS_UPDATES',
  'SAVE_TEXT',
  'DELETE_TEXT',
  'UPDATE_TEXT_POSITION',
  'UPDATE_TEXT_STYLES',
  'UPDATE_IMAGE_CONTAINER_DIMENSIONS',
  'CLIPBOARD_PASTE_IMAGE',
  'FETCH_IMAGE_DOWNLOAD_URLS',
]);

export function resetIllustration() {
  return {
    type: actions.RESET,
  };
}

export function addSlide() {
  return {
    type: actions.ADD_SLIDE,
  };
}

export function slidesRequest(payload) {
  return {
    type: actions.SLIDES_REQUEST,
    payload,
  };
}

export function slidesSuccess(payload) {
  return {
    type: actions.SLIDES_SUCCESS,
    payload,
  };
}

export function deleteSlide(payload) {
  return {
    type: actions.DELETE_SLIDE,
    payload,
  };
}

export function slideRequest(payload) {
  return {
    type: actions.SLIDE_REQUEST,
    payload,
  };
}

export function slideSuccess(payload) {
  return {
    type: actions.SLIDE_SUCCESS,
    payload,
  };
}

export function addImage(payload) {
  return {
    type: actions.ADD_IMAGE,
    payload,
  };
}

export function deleteImage(payload) {
  return {
    type: actions.DELETE_IMAGE,
    payload,
  };
}

export function uploading(payload) {
  return {
    type: actions.UPLOADING,
    payload,
  };
}

export function updateImageStyles(payload) {
  return {
    type: actions.UPDATE_IMAGE_STYLES,
    payload,
  };
}

export function addSlideNotes(payload) {
  return {
    type: actions.ADD_SLIDE_NOTES,
    payload,
  };
}

export function toggleLoading(payload) {
  return {
    type: actions.TOGGLE_LOADING,
    payload,
  };
}

export function setSlideThumbnail(payload) {
  return {
    type: actions.SET_SLIDE_THUMBNAIL,
    payload,
  };
}

export function addComment(payload) {
  return {
    type: actions.ADD_COMMENT,
    payload,
  };
}

export function updateCommentDotPosition(payload) {
  return {
    type: actions.UPDATE_COMMENT_DOT_POSITION,
    payload,
  };
}

export function resolveComment(payload) {
  return {
    type: actions.RESOLVE_COMMENT,
    payload,
  };
}

export function editComment(payload) {
  return {
    type: actions.EDIT_COMMENT,
    payload,
  };
}

export function deleteComment(payload) {
  return {
    type: actions.DELETE_COMMENT,
    payload,
  };
}

export function listenCommentsUpdates(payload) {
  return {
    type: actions.LISTEN_COMMENTS_UPDATES,
    payload,
  };
}

export function saveText(payload) {
  return {
    type: actions.SAVE_TEXT,
    payload,
  };
}

export function deleteText(payload) {
  return {
    type: actions.DELETE_TEXT,
    payload,
  };
}

export function updateTextPosition(payload) {
  return {
    type: actions.UPDATE_TEXT_POSITION,
    payload,
  };
}

export function updateTextStyles(payload) {
  return {
    type: actions.UPDATE_TEXT_STYLES,
    payload,
  };
}

export function updateImageContainerDimensions(payload) {
  return {
    type: actions.UPDATE_IMAGE_CONTAINER_DIMENSIONS,
    payload,
  };
}

export function clipboardPasteImage(payload) {
  return {
    type: actions.CLIPBOARD_PASTE_IMAGE,
    payload,
  };
}

export function fetchImageDownloadURLs() {
  return {
    type: actions.FETCH_IMAGE_DOWNLOAD_URLS,
  };
}
